<template>
  <div class="page">
    <div>
      <div class="m-bg">
        <p>{{CONFIG_ITEM.name}}</p>
      </div>
      <div  class="m-box-nav">
        <div v-if="verifyUserInfo==1" class="m-top-nav">
          <p class="x-font-color">个人信息</p>
          <div v-if="indicate('realName')" class="x-flex-between"><span>姓名</span><span>{{infoMore.realName}}</span></div>
          <div v-if="indicate('idCardNum')" class="x-flex-between"><span>证件号码</span><span class="ellipsis">{{infoMore.idCardNum}}</span></div>
          <div v-if="indicate('phone')" class="x-flex-between"><span>手机号码</span><span class="ellipsis">{{infoMore.phone}}</span></div>
          <div v-if="indicate('examinationNumb')" class="x-flex-between"><span>考籍号</span><span class="ellipsis">{{infoMore.examinationNumb}}</span></div>
          <div v-if="indicate('userType')" class="x-flex-between"><span>考生类型</span><span class="ellipsis">{{infoMore.userType}}</span></div>
          <div v-if="indicate('userMajor')" class="x-flex-between"><span>考生专业</span><span class="ellipsis">{{infoMore.userMajor}}</span></div>
          <div v-if="indicate('userSubName')" class="x-flex-between"><span>考生学科</span><span class="ellipsis">{{infoMore.userSubName}}</span></div>
        </div>
        <div v-if="relevanceExam==1" class="m-bottom-nav">
          <m-from-nav ref="mFrom" :register="register"/>
        </div>
        <div v-if="templateId" class="m-bottom-nav">
          <m-info-nav ref="mItem" :templateId="templateId" />
        </div>
        <div v-if="register.hasRegisterConfirm==1" style="margin: 15px 0 0 0;">
          <van-checkbox  icon-size="22px" v-model="checked" checked-color="#ee0a24">
            <span style="color: red;font-size: 16px;">{{register.registerConfirmCopywriting}}</span>
          </van-checkbox>
        </div>
        <div class="m-footer x-flex-between">
          <!--<van-button v-if="register.registerFee==1" block class="m-btn-default x-font-color" @click="$router.go(-1)">上一步</van-button>-->
          <van-button v-if="register.registerFee==1" block class="x-btn-log m-btn-next" @click="goTo()" :disabled="isGood" >下一步</van-button>
          <van-button v-if="(register.registerFee==0||register.registerFee==null)&&(register.hasOfflinePay!=1)" block class="x-btn-log" @click="goTo(true)" :disabled="isGood">报名</van-button>
          <van-button v-if="(register.registerFee==0||register.registerFee==null)&&(register.hasOfflinePay==1)" block class="x-btn-log" @click="goTo(true)" :disabled="isGood">下一步</van-button>
        </div>
      </div>
    </div>
    <!--弹出退出确认框-->
    <van-popup v-model="isShow" round get-container="body" :close-on-click-overlay="false">
      <div class="m-popup">
        <div class="m-title">{{register.popTitle}}</div>
        <div class="m-des" v-html="register.popContent"></div>
        <div class="m-chose">
          <p @click="goLook()" :style="this.downTime>0 ? 'color:#E7E7E7' : ''">确 定<span style="color: #2B6CF9;font-weight: bold">{{downTime>0 ? `(${downTime})` : ''}} </span></p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { mapGetters } from 'vuex'
  import mFromNav from "./components/m-from-nav"
  import mInfoNav from "./components/m-info-nav"
  export default {
    components: {mFromNav,mInfoNav},
    computed: {
      ...mapGetters({
        CONFIG_ITEM: 'enroll/configItem',
      }),
      isGood() {
        if(this.register&&this.register.hasRegisterConfirm==1){
          if(!this.checked){
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    data () {
      return {
        exam:{},
        infoMore:{},
        verifyUserInfo:'',
        relevanceExam:'',
        templateId:'',
        userShowList:[],
        register:{},
        isShow:false,
        downTime:'',
        isOk:true,
        bol:false,
        checked:false,
      }
    },
    created () {
      this.getSetCofig()
//      this.getInfo()
    },
    methods: {
      goTo(bol){
        if(this.register.hasRegisterConfirm==1){
          if(!this.checked){
            this.utils.toastNone('请勾选，确认操作！')
            return
          }
        }
        this.bol = bol ? bol : ''
        let mFrom = this.$refs.mFrom
        if(this.templateId){
          let mItem = this.$refs.mItem
          mItem.submitClaim()
          let fieldObj = mItem.fieldObj
          let fieldArray = mItem.fieldArray
          let bools = fieldArray.find((item)=>{
            if(item.required&&!(fieldObj[item.nameKey])){
              return true
            } 
          })
          if(bools){
            this.utils.toastNone('请完善报考信息！')
            return
          }
        }

        if(this.register.subjectRequired==1){
          if(mFrom&&!mFrom.examSubject){
            this.utils.toastNone('请选择考试科目！')
            return
          }
        }
        if(this.register.siteRequired==1){
          if(!mFrom.examSiteId){
            this.utils.toastNone('请选择考点！')
            return
          }
        }
        if(this.register.regionsRequired==1){
          if(!mFrom.examRegions){
            this.utils.toastNone('请选择考区！')
            return
          }
        }
        if(this.register.hasGraduation==1){
          if(!mFrom.isName){
            this.utils.toastNone('请选择在籍状态！')
            return
          }
          if((mFrom.isState+''==='0')&&!(mFrom.timeLine)){
            this.utils.toastNone('请选择毕业时间！')
            return
          }
          if((this.register.hasTheoryGrade==1)&&(mFrom.isState+''==='0')&&!(mFrom.theoryGrade)){
            this.utils.toastNone('请选择论文成绩！')
            return
          }
          if((mFrom.isState+''==='0')){
            let time1 =  this.dayjs(this.register.graduationDeadline).format('YYYY-MM')
            let time2 =  this.dayjs(mFrom.timeLine).format('YYYY-MM')
//            console.log(time1,time2)
            if(this.dayjs(time1)>=this.dayjs(time2)){
              this.utils.toastNone('毕业时间已超过学位申请时间，无法报名！')
              return
            }
          }
        }
        if(this.register.registerPop==1){
          this.isShow = true
          if(this.register.popDuration>0){
            this.downTime = this.register.popDuration
           let time = setInterval(()=>{
              if(this.downTime>0){
                this.downTime = this.downTime-1
              } else {
                this.downTime = 0
                clearInterval(time)
              }
            },1000)
          }else {
            this.downTime = 0
          }
        } else {
          this.submit()
        }
      },
      submit(){
        let mFrom = this.$refs.mFrom
        let msg = {
          id: this.CONFIG_ITEM.id,
          examId: this.exam.id,
        }
        if(this.relevanceExam==1){
          msg.examSubject = mFrom.examSubject
          msg.examSiteId = (mFrom.examSiteId||mFrom.examSiteId===0) ? mFrom.examSiteId : null
          msg.userAddress = mFrom.userAddress
          msg.hasNative = mFrom.isState
          msg.graduationTime = mFrom.timeLine
          msg.theoryGrade = mFrom.theoryGrade
          msg.examRegions = mFrom.examRegions
        }
        if(this.templateId){
          let mItem = this.$refs.mItem
          msg = {...msg,userInfoExtPO:{...mItem.fieldObj}}
        }
        if(this.register.hasOfflinePay&&this.register.hasOfflinePay==1){
          let params = JSON.stringify(msg)
          this.$router.push({
            name:'codePay',
            params:{msg:params}
          })
          return
        }
        this.http.postRequest({
          url:'app/exam/submitUserExamInfo',
          msg:msg,
          success:(res)=>{
            if(this.register.hasExamine&&this.register.hasExamine!=1){
              if(this.bol){
                this.$router.push({
                  path:'/enrollSuccess',
                })
              }else {
                this.$router.push({
                  path:'/examPay',
                  query:this.$route.query
                })
              }
            }else {
              this.$router.push({
                path:'/waitResult',
              })
            }
          }
        },true)
      },
      getInfo(){
        this.http.getRequest({
          url:`app/exam/findExamInfo/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            let data = res.data
            if(data){
              if(data.exam&&this.relevanceExam==1){
                this.exam = data.exam
                this.$refs.mFrom.exam = this.exam
              }
              if(data.userInfoVO){
                this.infoMore = data.userInfoVO
              }
              if(data.siteList&&this.relevanceExam==1){
                if(this.register.regionsRequired==1){
                  this.$refs.mFrom.siteList = []
                } else {
                  this.$refs.mFrom.siteList = data.siteList
                }
              }
              if(data.examRegionsList&&this.relevanceExam==1){
                this.$refs.mFrom.areaList = data.examRegionsList
              }
              if(data.subjectList&&this.relevanceExam==1){
                this.$refs.mFrom.subjectList = data.subjectList
              }
              if(this.$route.query.id&&this.relevanceExam==1){
                this.getIdInfo(data.subjectList,data.siteList,data.examRegionsList)
              }
            }
          }
        })
      },
      getSetCofig(){
        this.http.getRequest({
          url:`app/exam/findRegisterInfo/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            this.getInfo()
            this.register = res.data&&res.data.register ? res.data&&res.data.register : {}
            this.verifyUserInfo = res.data&&res.data.register&&res.data.register.verifyUserInfo ? res.data.register.verifyUserInfo : ''
            this.relevanceExam = res.data&&res.data.register&&res.data.register.relevanceExam ? res.data.register.relevanceExam : ''
            this.templateId = res.data&&res.data.register&&res.data.register.templateId ? res.data.register.templateId : ''
            this.userShowList = res.data&&res.data.userShowList&&res.data.userShowList ? res.data.userShowList : []
          }
        })
      },
      indicate(i){
        return this.userShowList.some(item=>item===i)
      },
      goLook(){
        if(this.downTime>0){ return }
        this.isShow = false
        this.submit()
        let msg = new FormData()
        msg.append('logType', 2)
        this.http.postRequest({
          url: 'app/user/log/save',
          headers: {'Content-Type': 'multipart/form-data'},
          msg:msg,
          success:(res)=>{

          }
        })
      },
      //获取报考信息
      getIdInfo(subList,siteList,examRegionsList){
        this.http.getRequest({
          url:`app/exam/findRegisterInfoToModify/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            if(res.data){
              let data = res.data
              let mFrom = this.$refs.mFrom
              mFrom.result = data.subjectList ? data.subjectList : []
              if(data.subjectList.length){
                let str = ''
                mFrom.examSubject = data.subjectList.join(',')
                data.subjectList.forEach((item)=>{
                  subList.forEach((ite)=>{
                    if(item==ite.id){
                      str=str+' '+ite.name
                    }
                  })
                })
                mFrom.keMu = str
              }
              if(examRegionsList&&examRegionsList.length){
                mFrom.examRegions = data.regionsList&&data.regionsList[0] ? data.regionsList[0] : ''
                examRegionsList.forEach((item)=>{
                  if(item.id==data.regionsList[0]){
                    mFrom.kaoQu=item.name
                  }
                })
              }
              if(this.register.regionsRequired==1&&data.regionsList&&data.regionsList.length&&data.examSiteId){
                mFrom.examSiteId = data.examSiteId
                this.getSiteList(this.CONFIG_ITEM.id,data.regionsList[0],data.examSiteId)
              } else {
                mFrom.examSiteId = data.examSiteId
                if(data.examSiteId){
                  siteList.forEach((item)=>{
                    if(item.id==data.examSiteId){
                      mFrom.kaoDian=item.name
                    }
                  })
                }
              }
              mFrom.userAddress = data.userAddress
              if(this.register.hasGraduation==1){
                mFrom.isName = data.hasNative==1 ? '在籍' : '已毕业'
                mFrom.isState = data.hasNative
                mFrom.timeLine = data.graduationTime
                if(this.register.hasTheoryGrade==1){
                  mFrom.theoryGrade = data.theoryGrade  
                }
              }
            }
          }
        })
        
      },
      getSiteList(i,y,z){
        this.http.getRequest({
          url: `/app/exam/querySiteInfoByRegions/${i}/${y}`,
          msg: {},
          success: (res) => {
            let siteList =res.data
            if(siteList&&siteList.length){
              let mFrom = this.$refs.mFrom
              siteList.forEach((item)=>{
                if(item.id==z){
                  mFrom.kaoDian=item.name
                }
              })
            }

          }
        })
      }
    },
    mounted () {

    },
    
    filters: {
      numFilter:(value) =>{
        if (!value) return ''
        return value.replace(/(\w{6})\w*(\w{2})/, '$1******$2')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    background: #F4F6F9;
    >div{
      position: relative;
      .m-bg{
        padding: 20px 12px 0 12px;
        width: 100%;
        height: 180px;
        background: linear-gradient(180deg, #2B6CF9 0%, #2B6CF9 73%, rgba(43,108,249,0) 100%);
        position: absolute;
        z-index: 10;
        >p{
          font-size: 15px;
          color: #ffffff;
          -webkit-line-clamp: 2; // 设置两行文字溢出
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 20px;
        }
      }
      .m-box-nav{
        position: absolute;
        z-index: 20;
        top: 70px;
        left: 12px;
        right: 12px;
        .m-top-nav{
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          padding: 18px 12px 18px 12px;
          >p{
            font-weight: 600;
          }
          .x-flex-between{
            margin-top: 18px;
            >span{
              white-space: nowrap;
            }
            >span:first-child{
              margin-right: 20px;
              color: #8D8F93;
            }
          }
        }
        .m-bottom-nav{
          margin-top: 15px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          padding: 18px 12px 18px 12px;
        }
        .m-footer{
          margin: 30px 15px 40px 15px;
          .m-btn-default{
            width: 144px;
            background: #ffffff;
            border-radius: 8px;
          }
          .m-btn-next{
            /*width: 144px;*/
          }
        }
      }

    }

  }
  .m-popup {
    width: 300px;
    /*mim-height: 145px;*/
    background: #ffffff;
    font-size: 15px;
    .m-title {
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      height: 53px;
      line-height: 53px;

    }
    .m-des {
      padding: 0 20px 20px 20px;
      border-bottom: 1Px solid #E7E7E7;
      line-height: 20px;
      max-height: 60vh;
      overflow-y: auto;
    }
    .m-chose {
      display: flex;
      > p {
        flex: 1;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        font-weight: bold;
        color: #2B6CF9;
      }
      > p:nth-child(2) {
        color: #2B6CF9;
        border-left: 1Px solid #E7E7E7;
      }
    }
  }

  .van-popup--center.van-popup--round {
    border-radius: 4px !important;
  }
</style>

